;(function () {
  'use strict'

  angular
    .module('contrast.filtering')
    .factory('LoadFilterService', [LoadFilterService])

  function LoadFilterService() {
    var filters = {
      applicationQuickFilter: false,
      applicationLanguage: false,
      vulnerableLibraries: false,
      vulnerabilitiesFilter: false,
      serverApplications: false,
      servers: [],
      serverQuickFilter: false,
      environment: [],
      attackApplications: false,
      attackServers: false,
      attackSeverities: false,
      attackEventApps: false,
      attackEventRules: false,
      attackEventAttackers: false,
      attacksLive: false,
      attacksDate: false,
      attackTags: false,
      attackEventTags: false,
      attackEnvironment: false,
      attackStatus: false,
      attackType: false,
      noProbed: false,
      attackBB: false,
      attackIP: false,
      attackViewAllOn: false
    }

    return {
      /**
       * Used in New Grids
       */

      // App
      setApplicationsQuickFilter: setFilter('applicationQuickFilter'),
      getApplicationsQuickFilter: getFilter('applicationQuickFilter'),

      // App
      setApplicationLanguage: setFilter('applicationLanguage'),
      getApplicationLanguage: getFilter('applicationLanguage'),

      // App
      setServers: setFilter('servers'),
      getServers: getFilter('servers'),

      // Server
      setServersQuickFilter: setFilter('serverQuickFilter'),
      getServersQuickFilter: getFilter('serverQuickFilter'),

      // Server
      setServerApplications: setFilter('serverApplications'),
      getServerApplications: getFilter('serverApplications'),

      // Server
      setEnvironment: setFilter('environment'),
      getEnvironment: getFilter('environment'),

      // Vulns
      setVulnerabilitiesFilter: setFilter('vulnerabilitiesFilter'),
      getVulnerabilitiesFilter: getFilter('vulnerabilitiesFilter'),

      /**
       * End Used in new Grids
       */

      setVulnerableLibraries: setFilter('vulnerableLibraries'),
      getVulnerableLibraries: getFilter('vulnerableLibraries'),

      setAttackApplications: setFilter('attackApplications'),
      getAttackApplications: getFilter('attackApplications'),

      setAttackServers: setFilter('attackServers'),
      getAttackServers: getFilter('attackServers'),

      setAttackSeverities: setFilter('attackSeverities'),
      getAttackSeverities: getFilter('attackSeverities'),

      setAttackEventApps: setFilter('attackEventApps'),
      getAttackEventApps: getFilter('attackEventApps'),

      setAttackEventRules: setFilter('attackEventRules'),
      getAttackEventRules: getFilter('attackEventRules'),

      setAttackEventAttackers: setFilter('attackEventAttackers'),
      getAttackEventAttackers: getFilter('attackEventAttackers'),

      setAttacksLive: setFilter('attacksLive'),
      getAttacksLive: getFilter('attacksLive'),

      setAttacksDate: setFilter('attacksDate'),
      getAttacksDate: getFilter('attacksDate'),

      setAttackTags: setFilter('attackTags'),
      getAttackTags: getFilter('attackTags'),

      setAttackEventTags: setFilter('attackEventTags'),
      getAttackEventTags: getFilter('attackEventTags'),

      setAttackEnvironment: setFilter('attackEnvironment'),
      getAttackEnvironment: getFilter('attackEnvironment'),

      setAttackStatus: setFilter('attackStatus'),
      getAttackStatus: getFilter('attackStatus'),

      setAttackType: setFilter('attackType'),
      getAttackType: getFilter('attackType'),

      setNoProbed: setFilter('noProbed'),
      getNoProbed: getFilter('noProbed'),

      setAttackBB: setFilter('attackBB'),
      getAttackBB: getFilter('attackBB'),

      setAttackIP: setFilter('attackIP'),
      getAttackIP: getFilter('attackIP'),

      setAttackQuickFilter: setFilter('attackViewAllOn'),
      getAttackQuickFilter: getFilter('attackViewAllOn')
    }

    function getFilter(filterName) {
      return function () {
        return filters[filterName]
      }
    }

    function setFilter(filterName) {
      return function (val) {
        return (filters[filterName] = val)
      }
    }
  }
})()
